import ErrorIcon from "@mui/icons-material/Error";
import HomeIcon from "@mui/icons-material/Home";
import LoginIcon from "@mui/icons-material/Login";
import { Box, Button } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomTitle from "../components/app/CustomTitle";
import Flex from "../components/Flex";
import { appPaths } from "../constants/paths";

type ValueRoutName = "home" | "logIn";

interface ErrorPageProps {
  resetError: () => void;
}

const ErrorPage = ({ resetError }: ErrorPageProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const preLoaderContainer = document.getElementById("pre-loader-container");
    if (preLoaderContainer) preLoaderContainer.style.display = "none";

    return () => {
      if (preLoaderContainer) preLoaderContainer.style.display = "block";
    };
  }, []);

  const handleNavigate = (route: ValueRoutName) => {
    resetError();

    if (route === "home") {
      navigate(-1);
    } else if (route === "logIn") {
      navigate(appPaths.login);
    }

    window.location.reload();
  };

  return (
    <Flex
      width={"100%"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100svh"}
      flexDirection={"column"}
      gap={2}
    >
      <Box>
        <ErrorIcon sx={{ fontSize: "180px" }} color="error" />
      </Box>
      <CustomTitle fontSize={"30px"}>Something Went Wrong</CustomTitle>
      <CustomTitle>
        We are working on it and we'll get it fixed as soon as we can.
      </CustomTitle>
      <Flex
        width={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={7}
        mt={8}
      >
        <Button
          variant="outlined"
          onClick={() => handleNavigate("logIn")}
          startIcon={<LoginIcon />}
        >
          Go To Sign In Page
        </Button>
        <Button
          variant="contained"
          onClick={() => handleNavigate("home")}
          startIcon={<HomeIcon />}
        >
          Go Back
        </Button>
      </Flex>
    </Flex>
  );
};

export default ErrorPage;
